import { isBooleanQuery } from '@/components/AdvancedSearch/lib/isValidQuerySyntax'
import { factboxFields } from '@/components/AdvancedSearch/configs'

export type DocumentOrigin = 'core/factbox' | 'core/article' | undefined

/**
 * Article-embedded factboxes are indexed flattened per article, so a boolean search
 * cannot be evaluated per factbox. While one is active, originals are selected
 * unless the user chose an origin, and the automatic choice is undone once the
 * search turns plain again.
 */
export function nextDocumentOrigin({ text, origin, autoSelected }: {
  text: string
  origin: DocumentOrigin
  autoSelected: boolean
}): { origin: DocumentOrigin, autoSelected: boolean } {
  const ownChoice = autoSelected && origin === 'core/factbox'

  if (isBooleanQuery(text, factboxFields)) {
    return origin === undefined
      ? { origin: 'core/factbox', autoSelected: true }
      : { origin, autoSelected: ownChoice }
  }

  return ownChoice
    ? { origin: undefined, autoSelected: false }
    : { origin, autoSelected: false }
}
